// Modules
import React from 'react';
import Textarea from 'react-textarea-autosize';
import _ from 'lodash';

import { SVGButton } from 'components/widgets/buttons';
import { ignoreEnter } from 'utils/event-handlers';
import Time from 'modules/timers/time';
import Timer from 'services/data/timer';
import TimerRelations from 'modules/timers/timer-relations';
import TimerTimeReportForm from 'modules/timers/timer-time-report-form';

import * as actions from './actions';

export default class TimerElement extends React.Component {
  constructor() {
    super();

    this.updateDescription = this.updateDescription.bind(this);
    this.debouncedUpdate = _.debounce(actions.update, 500);
  }

  updateDescription(event) {
    const { timer } = this.props;

    actions.update({ ...timer, description: event.target.value }, { skipUpdate: true });

    this.debouncedUpdate({ ...timer, description: event.target.value });
  }

  render() {
    const { timer } = this.props;

    const active = Timer.isActive(timer);
    const archived = timer.status === 'Archived';
    const ticket = _.get(timer, 'ticket.description');
    const canAddTime = !active && ticket && !archived;

    if (!timer) return null;

    return (
      <div key={timer.uuid || timer.id} className="d-flex align-items-center">
        { !archived && <SVGButton onClick={() => actions.archive(timer)} title="Delete Timer" src="svg/delete.svg" className="btn-warning rounded-circle p-2 m-2" /> }
        { archived && <SVGButton onClick={() => actions.restore(timer)} title="Restore Timer" src="svg/refresh.svg" className="btn-success rounded-circle p-2 m-2" /> }
        <div className="flex-grow-1 pl-2">
          { !archived &&
            <Textarea
              onKeyPress={ignoreEnter()}
              className="unstyled-textarea"
              value={timer.description}
              onChange={this.updateDescription}
            />
          }
          { archived && <span className="text-silver">[deleted] {timer.description}</span> }
          <TimerRelations timer={timer} />
        </div>
        <div className="pr-2 mr-2"><Time timer={timer} /></div>
        { canAddTime && <TimerTimeReportForm timer={timer} />}
        { !canAddTime && <SVGButton title="Timers must be stopped, have a ticket, and not be deleted to create a time report" disabled src="svg/time-report.svg" className="btn-primary rounded-circle p-2 mr-2" /> }
        { !active && <SVGButton onClick={() => actions.start(timer)} disabled={archived} title="Start Timer" src="svg/play.svg" className="btn-success rounded-circle p-2 m-2" /> }
        { active && <SVGButton onClick={() => actions.stop(timer)} disabled={archived} title="Stop Timer" src="svg/stop.svg" className="btn-danger rounded-circle p-2 m-2" /> }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/timers/timer.js